import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function getConfig() {
  const { data } = await client.get("/config");
  return data;
}
export async function getZones() {
  const { data } = await client.get("/zones");
  return data;
}
export async function getStats() {
  const { data } = await client.get("/stats");
  return data;
}
export async function getDeals() {
  const { data } = await client.get("/deals");
  return data;
}
export async function getProperties(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const { data } = await client.get("/properties", { params: clean });
  return data;
}
export async function getProperty(slug, params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const { data } = await client.get(`/properties/${slug}`, { params: clean });
  return data;
}

export async function createAlert(payload) {
  const { data } = await client.post("/alerts", payload);
  return data;
}
export async function bookOffer(slug, params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const { data } = await client.get(`/book/offer/${slug}`, { params: clean });
  return data;
}
export async function bookConfirm(payload) {
  const { data } = await client.post("/book/confirm", payload);
  return data;
}
export async function createCheckout(payload) {
  const { data } = await client.post("/payments/checkout", payload);
  return data;
}
export async function getPaymentStatus(sessionId) {
  const { data } = await client.get(`/payments/status/${sessionId}`);
  return data;
}
export async function getHistory(slug, weeks = 8) {
  const { data } = await client.get(`/properties/${slug}/history`, { params: { weeks } });
  return data;
}
export async function listAlerts(email) {
  const { data } = await client.get("/alerts", { params: { email } });
  return data;
}
export async function deleteAlert(id) {
  const { data } = await client.delete(`/alerts/${id}`);
  return data;
}
export async function listBookings(token) {
  const { data } = await client.get("/bookings", { params: { token } });
  return data;
}
export async function requestBookingsLink(email, lang = "it") {
  const { data } = await client.post("/bookings/request-link", { email, lang });
  return data;
}
export function voucherUrl(ref) {
  return `${API}/bookings/${ref}/voucher`;
}
export async function resyncCatalog(token) {
  const { data } = await client.post("/admin/resync-catalog", null, {
    headers: { "x-admin-token": token },
  });
  return data;
}
export async function getAdminDescription(token, slug) {
  const { data } = await client.get(`/admin/description/${slug}`, {
    headers: { "x-admin-token": token },
  });
  return data;
}
export async function saveAdminDescription(token, slug, text, lang) {
  const { data } = await client.put(`/admin/description/${slug}`, { text, lang }, {
    headers: { "x-admin-token": token },
  });
  return data;
}
export async function getReviewShowcase(lang = "it", zone = null) {
  const { data } = await client.get("/reviews/showcase", { params: { lang, ...(zone ? { zone } : {}) } });
  return data;
}
export async function getAllReviews(slug, lang = "it", sort = "relevant", onlyCons = false) {
  const { data } = await client.get(`/properties/${slug}/all-reviews`, {
    params: { lang, sort, only_cons: onlyCons },
  });
  return data;
}
